import Vue from 'vue';
import VueRouter from 'vue-router';
import i18n from '../i18n';
import Home from '../views/Home.vue';
import AboutUs from '../views/AboutUs.vue';
import RoomRodia from '../views/RoomRodia.vue';
import RoomElia from '../views/RoomsElia.vue';
import RoomMirtia from '../views/RoomMirtia.vue';
import AgiosNikolaos from '../views/AgiosNikolaos.vue';
// import ContactUs from '../views/ContactUs.vue';
import PageContact from '../views/PageContact.vue';
import OutsideAreas from '../views/OutsideAreas.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: AboutUs,
  },
  {
    path: '/rodia',
    name: 'RoomRodia',
    component: RoomRodia,
  },
  {
    path: '/elia',
    name: 'RoomElia',
    component: RoomElia,
  },
  {
    path: '/myrtia',
    name: 'RoomMyrtia',
    component: RoomMirtia,
  },
  {
    path: '/agiosnikolaos',
    name: 'AgiosNikolaos',
    component: AgiosNikolaos,
  },
  {
    path: '/outside',
    name: 'OutsideAreas',
    component: OutsideAreas,
  },
  {
    path: '/contact',
    name: 'PageContact',
    component: PageContact,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  i18n.locale = localStorage.getItem('language') || 'gr';
  return next();
});

export default router;
